import styled from "styled-components";

const Container = styled.div`
  padding: 0em 1em 0 1em;
`;
const Header = styled.div`
  color: #85714d;
  display: flex;
  align-items: center;
  position: relative;
`;

const Title = styled.div`
  padding-left: 0.5em;
`;

const Icon = styled.div`
  font-size: 1em;
`;

const Widget = { Container, Header, Title, Icon };

export default Widget;
